// URL de la landing pública (suscri.net) desde la web app.
// Si VITE_LANDING_URL está definida en build (p. ej. en Docker local), tiene prioridad;
// si no, se autodetecta a partir del dominio (app.suscri.net -> suscri.net).
export function getLandingUrl(): string {
  const envLandingUrl = import.meta.env.VITE_LANDING_URL;
  if (envLandingUrl) {
    return envLandingUrl.replace(/\/$/, '');
  }
  const { protocol, host } = window.location;
  if (/^localhost(:\d+)?$/.test(host)) return `${protocol}//localhost:47080`;
  return `${protocol}//${host.replace(/^app\./, '')}`;
}
